import gql from 'graphql-tag';

const CAMPAIGN_ORDER_TRANSACTIONS_ALL = gql`
  query campaignOrderTransactionsAll(
    $where: CampaignOrderTransactionsWithEventsWhereInput!
    $orderBy: CampaignOrderTransactionsWithEventsOrderByInput
  ) {
    campaignOrderTransactionsWithEventses(where: $where, orderBy: $orderBy) {
      id
      orderId
      adProviderId
      totalImpressions
      revenue
      lastImpression
      transactionDate
      attrMethod
      attrValue
      attrWindow
      impressions(orderBy: impressionTime_DESC) {
        id
        eventId
        media
        creativeId
        creativeName
        impressionTime
        impressionPublisherPlatform
        impressionPublisherUrl
        impressionPublisher
        impressionPublisherMedia
        impressionPubliserViewed
        additionalInfo {
          id
          impressionDSP
          impressionPublisherID
          impressionPublisherDomain
          lineItemID
          insertionOrderId
          publisherAppStore
          publisherAppName
          siteId
          siteName
          publisherID
          publisherName
        }
      }
    }
  }
`;

export default CAMPAIGN_ORDER_TRANSACTIONS_ALL;
